import React, { Component } from 'react';
import Page from '../../components/Page';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import { toWapi, log, post } from '../../util/api';
import { getExcelLists, getContactListItems } from '../../util/contacts';
import { Picker } from 'emoji-mart';
import 'emoji-mart/css/emoji-mart.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import tr from 'date-fns/locale/tr';
import en from 'date-fns/locale/en-GB';
import es from 'date-fns/locale/es';
import fr from 'date-fns/locale/fr';
import pt from 'date-fns/locale/pt';
import ru from 'date-fns/locale/ru';
import de from 'date-fns/locale/de';
import {
	Icon,
	Btn,
	IconBtn,
	Card,
	CardHead,
	Field,
	Input,
	Textarea,
	Select,
	Combo,
	Check,
	SearchInput,
	Segmented,
	Badge,
	Tag,
	Stepper,
	Banner,
	KV,
	Pager,
	Modal,
	ConfirmModal,
	Spinner,
	COLORS,
	notify,
	num,
	paginate,
	searchMatch,
	phoneOf,
	readPref,
	writePref,
} from './ui';
import { WaFrame, TemplateBubble, MessageBubble } from './wapreview';
import ImportModal from './importmodal';
import { browserTz, groupByCountry, computeWaves, tzOffsetLabel, TIMEZONES } from './timezone';
import cs from 'classnames';
const dateLocales = { tr, en, es, pt, ru, fr, de };
const filterPassedTime = (time) => {
	const currentDate = new Date();
	const selectedDate = new Date(time);

	return currentDate.getTime() < selectedDate.getTime();
};
const time_options = [];
const PAGE_SIZE = 50;
function formatTime(value) {
	let dur = moment.duration(value);
	return moment(dur._data.minutes, 'm').format('mm') + ':' + moment(dur._data.seconds, 's').format('ss');
}
function formatTimeText(value) {
	let dur = moment.duration(value);
	return (
		dur._data.days * 24 +
		' gün ' +
		dur._data.hours +
		' saat ' +
		moment(dur._data.minutes, 'm').format('m') +
		' dakika ' +
		moment(dur._data.seconds, 's').format('s') +
		' saniye'
	);
}
for (var i = 1; i <= 40; i++) {
	time_options.push({ key: '' + i * 15, text: formatTime(i * 15000), value: i * 15000 });
}
function checkForImage(url, file_format) {
	let regexMedia = /^https?:\/\/.*\/.*\.(png|gif|webp|jpeg|jpg)\??.*$/gim;
	let regexVideo = /^https?:\/\/.*\/.*\.(mp4)\??.*$/gim;
	let regexVoice = /^https?:\/\/.*\/.*\.(ogg|mp3)\??.*$/gim;

	let result;
	if (url.match(regexMedia)) {
		result = 'image';
	} else if (url.match(regexVideo)) {
		result = 'video';
	} else if (url.match(regexVoice)) {
		result = 'audio';
	} else {
		result = 'unvalid';
	}
	if (file_format) result = file_format;
	//console.log('result', result);
	return result;
}
/* function timeChangeStart(value) {
	let { lasttime } = this.state;
	lasttime = moment(lasttime).set({ hour: moment(value, 'HH:mm').format('HH'), minute: moment('00', 'mm').format('mm') });
	this.setState({ lasttime });
} */
class Phone extends Component {
	state = {
		startDate: new Date(),
		phones: [],
		loading: true,
		targets: [],
		message_type: 'text',
		sw_groups: true,
		sw_contacts: false,
		start_date: new Date(),
		lasttime: new Date(),
		selectedTag: 'all',
		message: '',
		selectedSource: 'whatsappweb',
		phoneSource: 'contacts',
		sending_date: 'now',
		selectedAralik: 20 * 15000,
		// yeni arayüz
		step: 0,
		aside: readPref('wsm_send_aside', 'normal'), // normal | wide | collapsed
		q: '',
		page: 1,
	};
	async componentDidMount() {
		let { product } = this.props;
		this.getSchedulesList();
		await this.getContactList();
		await this.getLogTargets();
		await this.getListPhone();
		await this.getBusinessPhoneList();
		await this.getListExcel();
		await this.getListTable();
		let { phones } = this.state;
		for (let index = 0; index < phones.length; index++) {
			const element = phones[index];
			/* if (index === 0) */ this.getGroups(element.id);
		}
		if (product.settings.sendMessageContacts) this.setState({ sw_groups: false, sw_contacts: true });
		this.setState({ loading: false, tableloading: false });
		this.applyQueryTemplate();
	}
	// Şablonlar sekmesindeki "Kullan": /wsendmessage?template=ad&shop=numara
	applyQueryTemplate() {
		let { location } = this.props;
		let params = new URLSearchParams((location && location.search) || '');
		let name = params.get('template');
		if (!name) return;
		let shop = params.get('shop');
		this.pendingTemplate = name;
		let setShop = () => {
			let { businessPhoneList, selectedBusinessphone } = this.state;
			if (shop && shop !== selectedBusinessphone && _.find(businessPhoneList, { value: shop })) this.setState({ selectedBusinessphone: shop });
			else this.applyPendingTemplate();
		};
		// selectedSource ve selectedBusinessphone aynı anda değişirse componentDidUpdate yalnızca ilkini işler
		if (this.state.selectedSource !== 'waba') this.setState({ selectedSource: 'waba' }, setShop);
		else setShop();
	}
	applyPendingTemplate() {
		let name = this.pendingTemplate;
		if (!name || !_.find(this.state.templates, { name })) return;
		this.pendingTemplate = null;
		this.setState({ template_id: name, message_type: 'template', step: 0 });
		this.initTemplateCards(name);
		this.initTemplateVars(name);
		notify(this.props.t('Şablon seçildi') + ': ' + name);
	}
	async getSchedulesList() {
		const { product } = this.props;
		let pid = product.id;
		return log('/api/listSchedules', {
			pid,
			limit: 1,
		}).then((data) => this.setState({ job_list: data.data.result }));
	}
	// Seçilen excel listesinin kişileri; liste seçildiğinde bir kez yüklenir.
	async loadExcelData(phoneSource) {
		let id = /^excel_/.test(phoneSource || '') && phoneSource.replace('excel_', '');
		let item = id && _.find(this.state.excelData, { _id: id });
		if (!item || item.data || this.loadingExcel === id) return;
		this.loadingExcel = id;
		this.setState({ excelLoading: true });
		let data = await getContactListItems(id).catch(() => []);
		this.loadingExcel = null;
		this.setState((prev) => ({ excelLoading: false, excelData: _.map(prev.excelData, (it) => (it._id === id ? { ...it, data } : it)) }));
	}
	async getListExcel() {
		const { t } = this.props;
		let excelData = await getExcelLists().catch(() => []);
		let phoneSourceList = [
			{
				value: 'contacts',
				text: t('contacts'),
			},
		];
		_.map(excelData, (it) => {
			phoneSourceList.push({
				value: 'excel_' + it._id,
				text: it.filename || moment(it.date).format('DD-MM-YYYY HH:mm:ss'),
			});
		});
		this.setState({ excelData });
		if (excelData.length) this.setState({ phoneSourceList, phoneSource: 'excel_' + excelData[0]._id });
	}

	async getListTable() {
		const { product } = this.props;
		let pid = product.id;
		if (product.settings.merged_broadcast_list)
			await post('/broadcast/listBroadcastUser', { pid }).then((data) => {
				let list = data.data.result;
				let merged_excel_list =
					(list &&
						list.length &&
						_.map(list, (it) => ({
							Name: it.name,
							Phone: it.phone,
							tags: it.data.tag,
						}))) ||
					[];
				this.setState({
					merged_excel_list,
				});
			});
	}
	async getLogTargets() {
		let { product } = this.props;
		let pid = product.id;
		await log('/live/groupMessageLog/last', { pid }).then((data) => {
			let response = data.data && data.data.message;
			let targetsData = (response && response[0] && response[0].log && response[0].log.groups) || [];
			let targets = [];
			_.map(targetsData, (it) => targets.push(it));
			if (!product.settings.merged_broadcast_list && _.filter(targets, { number: 'waba' }).length) this.setState({ selectedSource: 'waba', targets: [] });
			else {
				this.setState({ targets });
			}
		});
	}
	async getListPhone() {
		let { product } = this.props;
		let pid = product.id;
		await toWapi(`/api/${pid}/listPhones`, product.settings.wapi_token)
			.then((data) => {
				if (data.status !== 200) {
					return;
				}
				data = _.orderBy(
					_.filter(data.data, function (it) {
						return it.type === 'whatsapp';
					}),
					'id'
				);
				_.map(data, (it) => (it.loading = true));
				/* _.map(data, async (it) => {
					let stats = await this.getQueue(it.id);
					let queue = stats.sending;
					it.stats = queue;
				}); */
				let dropdownList = _.map(
					_.filter(data, (o) => o.number),
					(it) => ({
						value: it.id,
						text: it.name ? `${it.name} · ${it.number}` : it.number,
					})
				);
				dropdownList = _.concat({ text: 'Hepsi', value: 'all' }, dropdownList);
				this.setState({
					dropdownList,
					phones: _.filter(data, (o) => o.number),
					phone_ids: _.map(data, (o) => o.id),
					btnLoading: false,
					selectedphone: dropdownList.length === 2 ? dropdownList[1] && dropdownList[1].value : dropdownList[0] && dropdownList[0].value,
				});
			})
			.catch((err) => {
				console.error(err);
			});
	}
	async getContactList() {
		let { product } = this.props;
		//console.log('product', product);
		let pid = product.settings.live.token;
		//let pid = product.id;
		await fetch('https://live.dahi.ai/blacklist/list', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				pid,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({
					blackList: data.result,
				});
			});
		await fetch('https://live.dahi.ai/analytics/dialogtab/userLabelList', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				pid,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({
					contactList: data.data,
				});
			});
		await post('/dahi/tag/list', {}).then((data) => {
			//console.log(data);
			this.setState({ tagList: data.data.result.result });
		});
	}
	async getBusinessPhoneList() {
		let { product } = this.props;
		let pid = product.id;
		await post('/broadcast/phoneList', { pid }).then((data) => {
			let phones = data.data.phones;
			let businessPhoneList = [];
			if (phones && phones.length) {
				businessPhoneList = _.map(phones, (it) => ({
					value: it,
					text: it,
				}));
			}
			this.setState({ businessPhoneList, selectedBusinessphone: businessPhoneList && businessPhoneList[0] && businessPhoneList[0].value });
		});
	}
	async getBusinessTemplates(refresh = false) {
		let { selectedBusinessphone } = this.state;
		let { product } = this.props;
		let pid = product.id;
		await post('/broadcast/templateList ', { pid, shop: selectedBusinessphone, refresh }).then((data) => {
			//console.log('da', data);
			let templates = _.filter(data.data.templates, (it) => it.status === 'APPROVED' || it.status === 'approved');
			let template_config = data.data.config;
			let template_list = _.map(templates, (it) => ({
				text: it.name,
				value: it.name,
			}));
			this.setState({ templates, template_list, template_config, templateLoading: false }, () => this.applyPendingTemplate());
		});
	}
	componentDidUpdate(oldProps, oldState) {
		if (this.state.phoneSource !== oldState.phoneSource) this.loadExcelData(this.state.phoneSource);
		const check_list = ['selectedSource', 'selectedBusinessphone', 'phoneSource'];
		for (let i = 0; i < check_list.length; i++) {
			const key = check_list[i];
			if (key === 'selectedBusinessphone') {
				if (this.state[key] !== oldState[key]) {
					this.getBusinessTemplates();
				}
			} else {
				if (this.state[key] !== oldState[key]) {
					if (this.state[key] === 'waba' || oldState[key] === 'waba') {
						this.setState({
							targets: [],
							message_type: this.state[key] === 'waba' ? 'template' : 'link',
						});
					} else if (key === 'phoneSource') {
						this.setState({ targets: [] });
					}
					break;
				}
			}
		}
	}
	async getGroups(phone_id) {
		let { phones, contactList } = this.state;
		let { product } = this.props;
		let pid = product.id;
		let sendMessageContacts = product.settings.sendMessageContacts;
		let type = sendMessageContacts ? 'type=contact' : '';
		let data = await toWapi(`/api/${pid}/${phone_id}/contacts?${type}`, product.settings.wapi_token)
			.then((data) => {
				if (data.status !== 200) {
					return;
				}
				return data.data && data.data.data;
			})
			.catch((err) => {
				_.find(phones, { id: phone_id }).isError = true;
				console.error(err);
			});
		let fi = _.find(phones, { id: phone_id });
		_.map(contactList, (it) => {
			let sep = _.find(data, { id: it.phone + '@c.us' });
			if (sep) sep.tags = it.tags;
		});
		fi.groups = data;
		fi.loading = false;
		if (data && data.type === 'error') {
			_.find(phones, { id: phone_id }).isError = true;
		}
		//_.find(phones, { id: phone_id }).contacts = contacts_data;
		this.setState({ phones });
	}
	async postLog(data) {
		await log('/live/groupMessageLog/add', data);
	}
	fixPhone(number) {
		console.log('number1', number);
		number = '' + number;
		number = number.replace('+', '').replace(/ /gm, '');
		if (/^05/.test(number)) {
			number = '9' + number;
		} else if (/^5/.test(number)) {
			number = '90' + number;
		} else {
			number = number;
		}
		console.log('number2', number);
		return number;
	}
	// wave: ülke saatine göre planlamada tek dalga { targets, send_at, message_name }; dalga başına ayrı gönderim emri
	async sendMessage(isTest = false, wave) {
		let {
			targets,
			message,
			message_type,
			text_message,
			selectedSource,
			selectedBusinessphone,
			template_id,
			selectedphone,
			startDate,
			sending_date,
			testNumber,
			file_format,
			file_name,
			job_list,
			businessPhoneList,
			dropdownList,
			lasttime,
			selectedTag,
			message_name,
			phone_ids,
			template_params,
		} = this.state;
		if (wave) {
			targets = wave.targets;
			startDate = wave.send_at;
			sending_date = 'next';
			message_name = wave.message_name;
		}

		this.setState({ btnLoading: true });
		let { product } = this.props;
		let pid = product.id;
		let uid = product.uid;
		let logData = {},
			start_time;
		let diff_minute = moment(startDate).diff(moment(), 's');
		let isWapiLiveapi = product && product.settings && product.settings.wapiliveapi;
		let fixPhoneSending = product && product.settings && product.settings.fixPhoneSending;
		let randomPhoneId = product && product.settings && product.settings.randomPhoneId;
		//if (randomPhoneId) selectedphone = _.sample(phone_ids);
		if (sending_date === 'now') {
			start_time = 1;
		} else {
			start_time = Math.max(diff_minute, 1);
		}
		let hash = '' + new Date().getTime();
		if (message_type === 'link') file_format = 'link';
		if (message_type === 'gif') file_format = 'gif';
		if (message_type === 'sticker') file_format = 'sticker';
		if (!file_format) file_format = message_type;
		let content = { type: file_format, message: message };
		if (text_message) content.text = text_message;
		let extra = {};
		if (isTest) {
			let filtered_phones = _.filter(dropdownList, (it) => it.value !== 'all');
			let first_phone =
				selectedSource === 'waba'
					? (businessPhoneList[0] && businessPhoneList[0].value) || 'all'
					: (filtered_phones[0] && filtered_phones[0].value) || 'all';
			targets = [{ id: testNumber, name: testNumber, number: selectedphone === 'all' ? first_phone : selectedphone, phone: '' }];
		}

		if (product.settings.wsendwithdelay) {
			let max_phone_length = _.round(moment(lasttime).diff(moment(), 'seconds') / 60);
			targets = _.filter(targets, (it, i) => i < max_phone_length);
		}
		if (selectedSource === 'waba') {
			if (fixPhoneSending) {
				let _new_targets = _.map(targets, (it) => ({
					Name: it.Name || it.name,
					Phone: it.Phone ? this.fixPhone(it.Phone) : this.fixPhone(it.id),
					'Users Id': it.Phone ? this.fixPhone(it.Phone) : this.fixPhone(it.id),
					Label: it.Label,
					number: it.number,
					phone: it.phone,
					id: it.Phone ? this.fixPhone(it.Phone) : this.fixPhone(it.id),
					name: it.name,
					type: it.type,
				}));
				targets = _new_targets;
			}
			let new_id_ob = _.maxBy(job_list, (it) => parseInt(it.data.event.extra.id.replace(/.*_/, '')));

			let new_id =
				(new_id_ob &&
					new_id_ob.data &&
					new_id_ob.data.event &&
					/_/.test(new_id_ob.data.event.extra.id) &&
					parseInt(new_id_ob.data.event.extra.id.replace(/.*_/, ''))) ||
				0;
			//console.log('new_id', new_id_ob, new_id);
			extra = {
				source: 'liveapi',
				shop: selectedBusinessphone,
				numbers: _.map(targets, (it) => ({
					id: it.id,
					name: it.name || it.id,
					fields: it,
				})),
				start_time,
				id: selectedBusinessphone + '_' + (new_id + 1),
				template: {
					value: template_id,
					params: template_params || {},
				},
				template_image: this.state.template_image,
				template_cards: this.state.template_cards || undefined,
				singletonMinutes: 1,
				hash,
			};
			if (product.settings.wsendwithdelay) {
				extra.seconds = 60;
			}
			logData = {
				message: template_id,
				message_type,
				text_message,
				extra,
				template_name: template_id,
				groups: _.map(targets, ({ id, name, phone, number }) => ({
					id,
					name,
					phone,
					number,
				})),
			};
		} else {
			let new_id_ob = _.maxBy(job_list, (it) => it.data.event && it.data.event.extra && parseInt(it.data.event.extra.id.replace(/.*_/, '')));
			let new_id = (new_id_ob && new_id_ob.data && new_id_ob.data.event && parseInt(new_id_ob.data.event.extra.id.replace(/.*_/, ''))) || 0;
			if (fixPhoneSending) {
				let _new_targets = _.map(targets, (it) => ({
					Name: it.Name,
					Phone: this.fixPhone(it.Phone),
					'Users Id': this.fixPhone(it.Phone),
					Label: it.Label,
					number: it.number,
					phone: it.phone,
					id: this.fixPhone(it.Phone),
					name: it.name,
					type: it.type,
				}));
				targets = _new_targets;
			}
			if (isWapiLiveapi) {
				//console.log('isWapi-live', file_format);
				if (file_format === 'media' && message_type === 'media') {
					file_format = checkForImage(message);
				}
				if (file_format === 'image' || file_format === 'video' || file_format === 'document') {
					content = {
						type: file_format,
						imageUrl: message,
						targetlist: selectedTag,
						message_name,
						hash,
						template: { name: selectedphone + '_' + (new_id + 1) },
					};
					if (text_message) content.text = text_message;
					if (file_format === 'document') content.filename = file_name;
				} else if (file_format === 'link') {
					content = {
						type: 'link',
						url: message,
						targetlist: selectedTag,
						message_name,
						hash,
						template: { name: selectedphone + '_' + (new_id + 1) },
					};
					if (text_message) content.text = text_message;
				} else if (file_format === 'audio') {
					content = {
						type: 'audio',
						imageUrl: message,
						targetlist: selectedTag,
						message_name,
						hash,
						template: { name: selectedphone + '_' + (new_id + 1) },
					};
					if (text_message) content.text = text_message;
				} else if (file_format === 'gif') {
					content = {
						type: 'video',
						imageUrl: message,
						targetlist: selectedTag,
						isGif: true,
						message_name,
						hash,
						template: { name: selectedphone + '_' + (new_id + 1) },
					};
					if (text_message) content.text = text_message;
				} else if (file_format === 'sticker') {
					content = {
						type: 'image',
						imageUrl: message,
						targetlist: selectedTag,
						isSticker: true,
						message_name,
						hash,
						template: { name: selectedphone + '_' + (new_id + 1) },
					};
				} else {
					content = {
						type: 'text',
						text: message,
						targetlist: selectedTag,
						message_name,
						hash,
						template: { name: selectedphone + '_' + (new_id + 1) },
					};
				}
			} else {
				if (file_format === 'image' || file_format === 'video' || file_format === 'document' || file_format === 'audio') {
					content = { type: 'media', message, template: { name: selectedphone + '_' + (new_id + 1) } };
					if (text_message) content.text = text_message;
				}
			}
			extra = {
				source: isWapiLiveapi ? 'wapi-liveapi' : 'wapi',
				numbers: _.map(targets, (it) => ({
					id: '' + it.id,
					name: it.name || it.Name || it.id,
					phone_id: it.number,
				})),
				phone_id: selectedphone,
				phone_ids,
				randomPhoneId,
				id: selectedphone + '_' + (new_id + 1),
				content,
				start_time,
				singletonMinutes: 1,
				targetlist: selectedTag,
				message_name,
				hash,
			};
			if (product.settings.wsendwithdelay) {
				extra.seconds = 60;
			}
			if (!extra.seconds) {
				extra.seconds = this.state.selectedAralik / 1000;
			}
			logData = {
				message,
				message_type,
				text_message,
				template_name: selectedphone + '_' + (new_id + 1),
				extra,
				groups: _.map(targets, ({ id, name, phone, number }) => ({
					id,
					name,
					phone,
					number,
				})),
			};
		}
		//return console.log('targets', targets);
		try {
			if (!isTest) this.postLog({ pid, uid, log: logData });
			await log('/api/addSchedule', {
				category: 'schedule',
				label: 'broadcast_message_event',
				extra,
				pid,
			});
		} catch (err) {
			this.setState({ btnLoading: false });
			let data = err && err.response && err.response.data;
			notify((data && (data.message || data.error)) || (err && err.message) || this.props.t('Gönderim oluşturulamadı.'), 'err');
			return false;
		}
		// dalgalar sırayla gider; sonraki dalganın emir numarası güncel listeden hesaplanır
		if (wave) return true;
		this.getSchedulesList();
		this.setState({ btnLoading: false, openModal: false, openTestModal: false });
		let { t } = this.props;
		if (isTest) notify(t('Test mesajı kuyruğa alındı') + ': ' + testNumber);
		else
			notify(
				sending_date === 'next'
					? t('Gönderim planlandı') + ': ' + moment(startDate).format('DD.MM.YYYY HH:mm') + ' · ' + targets.length + ' ' + t('alıcı')
					: t('Gönderim başlatıldı') + ': ' + targets.length + ' ' + t('alıcı')
			);
	}
	// Ülke yerel saatine göre: her dalga için ayrı planlı gönderim
	async sendWaves() {
		let { t } = this.props;
		let waves = this.getWaves();
		let { message_name } = this.state;
		let done = 0;
		this.setState({ wavesSending: true });
		for (let i = 0; i < waves.length; i++) {
			let w = waves[i];
			await this.getSchedulesList().catch(() => {});
			let ok = await this.sendMessage(false, { targets: w.targets, send_at: w.send_at, message_name: _.compact([message_name, w.label]).join(' · ') });
			if (!ok) break;
			done++;
		}
		this.getSchedulesList();
		this.setState({ wavesSending: false, btnLoading: false });
		if (done === waves.length) {
			this.setState({ openModal: false });
			notify(t('Gönderim planlandı') + ': ' + waves.length + ' ' + t('dalga') + ' · ' + this.state.targets.length + ' ' + t('alıcı'));
		} else if (done) notify(t('{{done}} / {{total}} dalga planlandı; kalanlar oluşturulamadı.', { done, total: waves.length }), 'warn');
	}
	getWaves() {
		let { targets, startDate, weekendRule, tzOverrides } = this.state;
		let refTz = browserTz();
		return computeWaves(groupByCountry(targets, refTz, tzOverrides), {
			dateStr: moment(startDate).format('YYYY-MM-DD'),
			timeStr: moment(startDate).format('HH:mm'),
			weekendRule,
			refTz,
		});
	}
	onEmojiClick = (emoji, event) => {
		let { message } = this.state;
		let start_index = document.getElementById('message_area').selectionEnd;
		let native = emoji.native;
		message = message && message.substr(0, start_index) + native + message.substr(start_index);
		this.setState({ message });
	};
	textEditor(icon) {
		let { message } = this.state;
		let start_index = document.getElementById('message_area').selectionStart,
			end_index = document.getElementById('message_area').selectionEnd;
		message = message && message.substr(0, start_index) + icon + message.substr(start_index);
		message = message && message.substr(0, end_index + 1) + icon + message.substr(end_index + 1);
		this.setState({ message });
	}
	textEditorText(icon) {
		let { text_message } = this.state;
		let start_index = document.getElementById('message_area_text').selectionStart,
			end_index = document.getElementById('message_area_text').selectionEnd;
		text_message = text_message && text_message.substr(0, start_index) + icon + text_message.substr(start_index);
		text_message = text_message && text_message.substr(0, end_index + 1) + icon + text_message.substr(end_index + 1);
		this.setState({ text_message });
	}
	onEmojiClickText = (emoji, event) => {
		let { text_message } = this.state;
		let start_index = document.getElementById('message_area_text').selectionEnd;
		let native = emoji.native;
		text_message = text_message && text_message.substr(0, start_index) + native + text_message.substr(start_index);
		this.setState({ text_message });
	};
	handleChange = (e, { name, value }) => {
		/* const curr = this.state.selectedphone;
		if ((curr !== 'waba' && value === 'waba') || (curr === 'waba' && value !== 'waba')) {
			this.setState({ targets: [] });
		} */
		if (name === 'message_type') this.setState({ file_format: '' });
		this.setState({ [name]: value });
		if (name === 'selectedphone' && value === 'all') this.setState({ sw_contacts: false });
		if (name === 'template_id') {
			this.initTemplateCards(value);
			this.initTemplateVars(value);
		}
	};
	// Seçilen template carousel ise gönderim-anı kart override yapısını kurar.
	getSelectedTemplate = (name) => _.find(this.state.templates || [], (t) => t.name === name);
	getCarouselComp = (tpl) => tpl && _.find(tpl.components || [], (c) => (c.type || '').toUpperCase() === 'CAROUSEL');
	initTemplateCards = (name) => {
		let tpl = this.getSelectedTemplate(name);
		let carousel = this.getCarouselComp(tpl);
		if (!tpl || !carousel) {
			this.setState({ template_cards: null, template_carousel_type: null });
			return;
		}
		let isProduct = _.some(carousel.cards, (c) => _.find(c.components, (x) => (x.type || '').toUpperCase() === 'HEADER' && (x.format || '').toUpperCase() === 'PRODUCT'));
		let cards = _.map(carousel.cards, (card) => {
			let body = _.find(card.components, (c) => (c.type || '').toUpperCase() === 'BODY');
			let btns = _.find(card.components, (c) => (c.type || '').toUpperCase() === 'BUTTONS');
			let bodyVarCount = ((body && body.text) || '').match(/{{\d+}}/g);
			if (isProduct) return { product_retailer_id: '', catalog_id: '' };
			// buttons dizisi TAM buton sayısı kadar (composer index'i tam sıraya göre okur);
			// sadece dinamik URL butonlarının değeri gönderimde girilir.
			return {
				url: '',
				body_params: bodyVarCount ? bodyVarCount.map(() => '') : [],
				buttons: ((btns && btns.buttons) || []).map(() => ({ url: '' })),
			};
		});
		this.setState({ template_cards: cards, template_carousel_type: isProduct ? 'PRODUCT' : 'MEDIA' });
	};
	// Seçilen template'in BODY metnindeki değişkenleri bulur — hem pozisyonel ({{1}}) hem isimli ({{order_id}});
	// id'ler backend'deki bootTemplate ile birebir eşleşir (BODY-{{n}} / BODY-{{ad}}).
	getBodyVars = (tpl) => {
		let body = tpl && _.find(tpl.components, (c) => (c.type || '').toUpperCase() === 'BODY');
		let match = body && body.text && body.text.match(/{{\s*[A-Za-z0-9_]+\s*}}/g);
		match = (match && _.sortedUniq(match)) || [];
		return _.map(match, (code) => ({ code, id: `BODY-${code}` }));
	};
	initTemplateVars = (name) => {
		let tpl = this.getSelectedTemplate(name);
		let template_vars = this.getBodyVars(tpl);
		let template_params = {};
		_.each(template_vars, (v) => (template_params[v.id] = { mode: 'text', value: '' }));
		this.setState({ template_vars, template_params });
	};
	setTemplateParam = (id, patch) => {
		this.setState((prev) => ({ template_params: { ...prev.template_params, [id]: patch } }));
	};
	// Değişken için 'listeden al' seçildiğinde önerilecek alanlar; WABA gönderim listesi her zaman excel/merged-list kaynaklıdır.
	getAvailableFields = () => {
		let { phoneSource, merged_excel_list, excelData } = this.state;
		let sampleRow;
		if (merged_excel_list && merged_excel_list.length) sampleRow = merged_excel_list[0];
		else {
			let _tempExcel = _.find(excelData, (it) => it._id === (phoneSource || '').replace('excel_', ''));
			sampleRow = _tempExcel && _tempExcel.data && _tempExcel.data[0];
		}
		let keys = sampleRow ? _.keys(_.omit(sampleRow, ['tags'])) : ['Name', 'Phone'];
		return _.map(keys, (k) => ({ text: k, value: k }));
	};
	setCardField = (ci, patch) => {
		this.setState((prev) => {
			let cards = (prev.template_cards || []).map((c, i) => (i === ci ? { ...c, ...patch } : c));
			return { template_cards: cards };
		});
	};
	setCardArrayField = (ci, field, ai, value) => {
		this.setState((prev) => {
			let cards = (prev.template_cards || []).map((c, i) => {
				if (i !== ci) return c;
				let arr = (c[field] || []).slice();
				arr[ai] = field === 'buttons' ? { ...arr[ai], url: value } : value;
				return { ...c, [field]: arr };
			});
			return { template_cards: cards };
		});
	};
	addProductCard = () => this.setState((prev) => ({ template_cards: [...(prev.template_cards || []), { product_retailer_id: '', catalog_id: '' }] }));
	removeProductCard = (ci) => this.setState((prev) => ({ template_cards: (prev.template_cards || []).filter((_, i) => i !== ci) }));
	uploadCardImage = (ci) => (e) => {
		let file = e.target.files[0];
		if (!file) return;
		let input = e.target;
		let fd = new FormData();
		fd.append('files[]', file);
		fetch('https://uploads.yapaytech.com/flow/uploadPermImage', { method: 'POST', body: fd })
			.then((r) => r.json())
			.then((data) => {
				let url = data && data.files && data.files[0] && data.files[0].url;
				if (url) this.setCardField(ci, { url });
			})
			.finally(() => {
				if (input) input.value = '';
			});
	};
	fileUpload(file, name, _name) {
		const url = 'https://uploads.yapaytech.com/flow/uploadImage';
		const formData = new FormData();
		formData.append('files[]', file);
		let image_url = '';
		let file_type = file.type;
		let file_format = '';
		if (/image/.test(file_type)) file_format = 'image';
		else if (/video/.test(file_type)) file_format = 'video';
		else if (/application/.test(file_type)) file_format = 'document';
		else if (/audio/.test(file_type)) file_format = 'audio';
		this.setState({ file_format, file_name: file.name, uploading: true });
		fetch(url, {
			method: 'post',
			body: formData,
		})
			.then((response) => {
				return response.json();
			})
			.then(async (data) => {
				image_url = data && data.files && data.files[0] && data.files[0].url;
				if (_name) {
					this.setState({ [_name]: image_url });
				} else this.setState({ message: image_url });
			})
			.catch(() => notify(this.props.t('Dosya yüklenemedi.'), 'err'))
			.finally(() => this.setState({ uploading: false }));
	}
	handleFileInput = (e, _name) => {
		let file = e.target.files[0];
		let name = e.target.name;
		e.target.value = '';
		if (file) this.fileUpload(file, name, _name);
	};
	handleChangeArray = (e, { name, value }) => this.setState({ [name]: value });
	toggle = (o, number, phone) => {
		let { targets } = this.state;
		let isCheck = _.find(targets, { id: o.id, number });
		o.number = number;
		o.phone = phone;
		if (!isCheck) {
			targets.push(o);
		} else {
			_.remove(targets, function (it) {
				return it.id === o.id && it.phone === o.phone;
			});
		}
		this.setState({ targets });
	};
	toggleExcel = (o, number, base_phone) => {
		let { targets } = this.state;
		let isCheck = _.find(targets, { id: number });
		o.number = base_phone;
		o.phone = base_phone;
		o.id = number;
		o.name = o.Name;
		o.type = 'chat';
		if (!isCheck) {
			targets.push(o);
		} else {
			_.remove(targets, function (it) {
				return it.id === number;
			});
		}
		this.setState({ targets });
	};
	toggleSw = (e, { name }) => this.setState((prevState) => ({ [name]: !prevState[name] }));
	toggleAll = (o, number, phone) => {
		let { targets, phoneSource, blackList } = this.state;
		if (phoneSource !== 'contacts') {
			_.map(o, (it) => {
				it.number = number;
				it.phone = it.Phone;
				it.id = it.Phone;
				it.type = 'chat';
				let isCheck = _.find(targets, { id: it.Phone });
				let isBlackList = _.includes(blackList, '' + it.Phone);
				if (!isCheck && !isBlackList) return targets.push(it);
			});
		} else {
			_.map(o, (it) => {
				it.number = number;
				it.phone = phone;
				let isCheck = _.find(targets, { id: it.id });
				let isBlackList = _.includes(blackList, o.id && o.id.replace('@c.us', ''));
				if (!isCheck && !isBlackList) return targets.push(it);
			});
		}
		this.setState({ targets });
	};
	toggleAllExcel = (o) => {
		let { targets, blackList, selectedphone, selectedSource } = this.state;
		_.map(o, (it) => {
			it.number = selectedSource === 'waba' ? 'waba' : selectedphone;
			it.phone = selectedSource === 'waba' ? 'waba' : selectedphone;
			it.id = it.Phone;
			it.name = it.Name;
			let isCheck = _.find(targets, { id: it.Phone });
			let isBlackList = _.includes(blackList, '' + it.Phone);
			if (!isCheck && !isBlackList) return targets.push(it);
		});
		this.setState({ targets });
	};
	closeModal = () => {
		this.setState({ openModal: false, openListModal: false, btnLoading: false, openTestModal: false });
	};
	setStartDate = (date) => {
		this.setState({ start_date: new Date(date) });
	};

	// ───────────── Arayüz ─────────────
	setAside = (aside) => {
		writePref('wsm_send_aside', aside);
		this.setState({ aside });
	};
	goStep = (step) => this.setState({ step });
	// Adımın tamamlanması için eksik olan; boşsa adım tamam.
	stepError(step) {
		let { t } = this.props;
		let { targets, message_type, template_id, message } = this.state;
		if (step === 0 && !targets.length) return t('Devam etmek için en az bir alıcı seçin.');
		if (step === 1) {
			if (message_type === 'template' && !template_id) return t('Bir şablon seçin.');
			if (message_type !== 'template' && !message) return message_type === 'text' ? t('Mesaj metnini girin.') : t('Bağlantı girin veya dosya yükleyin.');
		}
		return '';
	}
	canGo = (i) => {
		for (let s = 0; s < i; s++) if (this.stepError(s)) return false;
		return true;
	};
	removeTarget = (i) => {
		let { targets } = this.state;
		targets.splice(i, 1);
		this.setState({ targets });
	};
	getMessageTypes() {
		let { t } = this.props;
		if (this.state.selectedSource === 'waba') return [{ value: 'template', label: t('Template') }];
		return [
			{ value: 'text', label: t('Yazı') },
			{ value: 'media', label: t('Medya') },
			{ value: 'link', label: t('Link') },
			{ value: 'document', label: t('document') },
			{ value: 'audio', label: t('audio') },
			{ value: 'gif', label: 'Gif' },
			{ value: 'sticker', label: 'Sticker' },
		];
	}
	lineLabel() {
		let { t } = this.props;
		let { selectedSource, selectedBusinessphone, selectedphone, dropdownList } = this.state;
		if (selectedSource === 'waba') return selectedBusinessphone || '—';
		if (selectedphone === 'all') return t('Tüm hatlar');
		let it = _.find(dropdownList, { value: selectedphone });
		return (it && it.text) || '—';
	}
	templateLabel(name) {
		let tpl = this.getSelectedTemplate(name);
		if (!tpl) return name;
		return [tpl.name, tpl.category, tpl.language].filter(Boolean).join(' · ');
	}
	// Seçili kaynağa göre alıcı satırları. Seçim mantığı (toggle / toggleExcel / toggleAll*) eski ekranla aynı.
	buildRecipients() {
		let { t } = this.props;
		let {
			phones,
			targets,
			sw_groups,
			sw_contacts,
			tagList,
			excelData,
			selectedSource,
			selectedphone,
			phoneSource,
			merged_excel_list,
			blackList,
			selectedTag,
			excelLoading,
		} = this.state;
		let merged = !!(merged_excel_list && merged_excel_list.length);
		let selectedphonedata = selectedphone === 'all' || selectedphone === 'waba' ? null : _.find(phones, { id: selectedphone });
		let showList = [],
			showExcelList = [];
		if (/excel/.test(phoneSource)) {
			let _tempExcel = _.find(excelData, (it) => it._id === phoneSource.replace('excel_', ''));
			showExcelList = _tempExcel && _tempExcel.data;
		} else {
			showExcelList = excelData && excelData[0] && excelData[0].data;
		}
		if (selectedSource !== 'waba' && selectedphonedata) {
			showList = _.orderBy(
				_.filter(selectedphonedata.groups, (it) => (it.type === 'group' && sw_groups) || (it.type === 'chat' && sw_contacts)),
				'type',
				'desc'
			);
		}
		if (merged) {
			showExcelList = merged_excel_list;
			showList = merged_excel_list;
		}
		let selectedTagObj = selectedTag !== 'all' && _.find(tagList, { _id: selectedTag });
		if (selectedTagObj && !merged) {
			showList = _.filter(showList, (it) => _.includes(it.tags, selectedTag));
			showExcelList = _.filter(showExcelList, (it) => _.includes(it.tags, selectedTagObj.title));
		} else if (selectedTagObj && merged) {
			showList = _.filter(showList, (it) => _.includes(it.tags, selectedTagObj.title));
			showExcelList = _.filter(showExcelList, (it) => _.includes(it.tags, selectedTagObj.title));
		}
		let tagsBy = (list, key) =>
			_.compact(
				_.map(list, (v) => {
					let tg = _.find(tagList, { [key]: v });
					return tg && { title: tg.title, color: tg.color || 'blue' };
				})
			);
		let blk = (p) => _.includes(blackList, '' + p);
		let excelRow = (it, i, number, checkWaba) => ({
			key: 'e' + i + '_' + it.Phone,
			name: it.Name || it.Phone,
			phone: it.Phone,
			tags: tagsBy(it.tags, 'title'),
			type: t('Kişi'),
			blacklisted: blk(it.Phone),
			checked: !!_.find(targets, checkWaba ? { id: it.Phone, number: 'waba' } : { id: it.Phone }),
			toggle: () => this.toggleExcel(it, it.Phone, number),
		});
		let groupRow = (o, phone, line) => ({
			key: phone.id + '_' + o.id,
			name: o.name,
			phone: o.type === 'chat' ? phoneOf(o.id) : '',
			line,
			tags: tagsBy(o.tags, '_id'),
			type: o.type === 'chat' ? t('Kişi') : t('Grup'),
			blacklisted: _.includes(blackList, o.id && o.id.replace('@c.us', '')),
			checked: !!_.find(targets, { id: o.id, number: phone.id }),
			toggle: () => this.toggle(o, phone.id, phone.number),
		});
		let res = { rows: [], selectAll: null, notices: [], showLine: false };
		if (/excel/.test(phoneSource) && excelLoading && !merged) res.notices.push({ loading: true, text: t('Liste yükleniyor…') });
		if (selectedSource === 'waba') {
			res.rows = _.map(showExcelList, (it, i) => {
				if (it.Label) it.tags = it.Label.split(',');
				return excelRow(it, i, 'waba', true);
			});
			res.selectAll = () => this.toggleAllExcel(showExcelList);
		} else if (merged) {
			res.rows = _.map(showExcelList, (it, i) => excelRow(it, i, 'waba'));
			res.selectAll = () => this.toggleAllExcel(showExcelList);
		} else if (selectedphone === 'all') {
			res.showLine = true;
			_.each(phones, (ph) => {
				if (ph.loading) res.notices.push({ loading: true, text: ph.number + ' · ' + t('gruplar yükleniyor…') });
				else if (ph.isError) res.notices.push({ error: true, text: ph.number + ' · ' + t('gruplar alınamadı') });
				else
					_.each(
						_.filter(ph.groups, (o) => o.type === 'group' && sw_groups),
						(o) => res.rows.push(groupRow(o, ph, ph.number))
					);
			});
		} else if (!selectedphonedata) {
			res.rows = [];
		} else if (phoneSource === 'contacts') {
			if (selectedphonedata.loading) res.notices.push({ loading: true, text: t('Kişi ve gruplar yükleniyor…') });
			else if (selectedphonedata.isError) res.notices.push({ error: true, text: t('error') });
			res.rows = _.map(showList, (o) => groupRow(o, selectedphonedata));
			res.selectAll = () => this.toggleAll(showList, selectedphonedata.id, selectedphonedata.number);
		} else {
			res.rows = _.map(showExcelList, (it, i) => excelRow(it, i, selectedphonedata.id));
			res.selectAll = () => this.toggleAll(showExcelList, selectedphonedata.id, selectedphonedata.number);
		}
		return res;
	}
	renderTags(tags) {
		if (!tags || !tags.length) return <span className="wsm-faint">—</span>;
		return (
			<div className="wsm-tags">
				{tags.map((tg, i) => (
					<Tag key={i} color={tg.color}>
						{tg.title}
					</Tag>
				))}
			</div>
		);
	}
	uploadButton(name, accept) {
		let { t } = this.props;
		return (
			<label className="wsm-iconbtn" style={{ width: 40, height: 40, cursor: 'pointer' }} title={t('Dosya yükle')}>
				{this.state.uploading ? <Spinner size={15} /> : <Icon name="upload" size={15} />}
				<input type="file" accept={accept || '*'} style={{ display: 'none' }} onChange={(e) => this.handleFileInput(e, name)} />
			</label>
		);
	}
	editorBar(target) {
		let { t } = this.props;
		let isText = target === 'text';
		let wrap = (ch) => (isText ? this.textEditorText(ch) : this.textEditor(ch));
		let open = this.state.emojiFor === target;
		return (
			<div className="wsm-editor-bar" style={{ position: 'relative' }}>
				<button type="button" className="wsm-iconbtn" title={t('Kalın')} onClick={() => wrap('*')}>
					B
				</button>
				<button type="button" className="wsm-iconbtn" title={t('İtalik')} onClick={() => wrap('_')} style={{ fontStyle: 'italic' }}>
					I
				</button>
				<button type="button" className="wsm-iconbtn" title={t('Üstü çizili')} onClick={() => wrap('~')} style={{ textDecoration: 'line-through' }}>
					S
				</button>
				<IconBtn icon="smile" title={t('Emoji')} size={28} active={open} onClick={() => this.setState({ emojiFor: open ? null : target })} />
				{open ? (
					<div className="wsm-emoji-pop">
						<Picker
							set="google"
							onClick={(emoji, ev) => {
								if (isText) this.onEmojiClickText(emoji, ev);
								else this.onEmojiClick(emoji, ev);
								this.setState({ emojiFor: null });
							}}
						/>
					</div>
				) : null}
			</div>
		);
	}

	// ── Adım 1: Alıcılar ──
	renderRecipients(R) {
		let { t } = this.props;
		let st = this.state;
		let { selectedSource, businessPhoneList, dropdownList, selectedphone, selectedBusinessphone, phoneSourceList, phoneSource, tagList, selectedTag, merged_excel_list } = st;
		let merged = !!(merged_excel_list && merged_excel_list.length);
		let waba = selectedSource === 'waba';
		let rows = _.filter(R.rows, (r) => searchMatch(st.q, r.name, r.phone));
		let pageRows = paginate(rows, st.page, PAGE_SIZE);
		let eligible = _.filter(pageRows, (r) => !r.blacklisted);
		let allOn = eligible.length > 0 && _.every(eligible, 'checked');
		let showListSource = !merged && (waba || selectedphone !== 'all');
		let listOptions = _.map(waba ? _.filter(phoneSourceList, (it) => it.value !== 'contacts') : phoneSourceList, (it) => ({ value: it.value, label: it.text }));
		if (showListSource && !listOptions.length) listOptions = waba ? [] : [{ value: 'contacts', label: t('contacts') }];
		let tagOptions = _.concat([{ value: 'all', label: t('Etiket') + ': ' + t('Hepsi') }], _.map(tagList, (it) => ({ value: it._id, label: it.title })));
		let lineOptions = waba
			? _.map(businessPhoneList, (it) => ({ value: it.value, label: it.text }))
			: _.map(dropdownList, (it) => ({ value: it.value, label: it.value === 'all' ? t('Tüm hatlar') : it.text }));
		let showKindChecks = !waba && !merged && (selectedphone === 'all' || phoneSource === 'contacts');
		let emptyText = waba
			? t('Listede kişi yok. "Yeni Excel yükle" ile bir dosya içe aktarın.')
			: selectedphone === 'all'
			? t('Seçili hatlarda grup bulunamadı.')
			: t('Bu kaynakta kişi bulunamadı.');
		return (
			<>
				<div className="wsm-section wsm-col" style={{ gap: 12 }}>
					{businessPhoneList && businessPhoneList.length ? (
						<Segmented
							value={selectedSource}
							onChange={(v) => this.setState({ selectedSource: v, page: 1 })}
							options={[
								{ value: 'whatsappweb', label: 'WhatsApp Web', icon: 'chat' },
								{ value: 'waba', label: 'WhatsApp Business', icon: 'sparkles' },
							]}
						/>
					) : null}
					<div className="wsm-grid3">
						<Field label={t('Hat')}>
							<Select
								value={waba ? selectedBusinessphone : selectedphone}
								options={lineOptions}
								placeholder={t('Hat bulunamadı')}
								onChange={(v) => {
									if (waba) this.setState({ selectedBusinessphone: v, page: 1 });
									else this.handleChange(null, { name: 'selectedphone', value: v });
								}}
							/>
						</Field>
						{showListSource ? (
							<Field
								label={t('Liste')}
								right={
									<button type="button" className="wsm-btn link" onClick={() => this.setState({ importOpen: true })}>
										+ {t('Yeni Excel yükle')}
									</button>
								}
							>
								<Select
									value={phoneSource}
									options={listOptions}
									placeholder={t('Henüz Excel yüklenmedi')}
									disabled={!listOptions.length}
									onChange={(v) => this.setState({ phoneSource: v, page: 1 })}
								/>
							</Field>
						) : null}
						{tagList && tagList.length ? (
							<Field label={t('label')}>
								<Select value={selectedTag} options={tagOptions} onChange={(v) => this.setState({ selectedTag: v, page: 1 })} />
							</Field>
						) : null}
					</div>
				</div>
				<div className="wsm-section" style={{ paddingTop: 12, paddingBottom: 12 }}>
					<div className="wsm-row" style={{ gap: 12 }}>
						<SearchInput value={st.q} onChange={(q) => this.setState({ q, page: 1 })} placeholder={t('İsim veya numara ara…')} />
						{showKindChecks ? (
							<>
								<Check
									label={t('Kişiler')}
									checked={st.sw_contacts}
									disabled={selectedphone === 'all'}
									onChange={() => this.toggleSw(null, { name: 'sw_contacts' })}
								/>
								<Check label={t('Gruplar')} checked={st.sw_groups} onChange={() => this.toggleSw(null, { name: 'sw_groups' })} />
							</>
						) : null}
					</div>
				</div>
				{R.notices.length ? (
					<div className="wsm-section wsm-col" style={{ gap: 8, paddingTop: 0 }}>
						{R.notices.map((n, i) => (
							<Banner key={i} tone={n.error ? 'danger' : 'muted'} icon={n.loading ? 'clock' : undefined}>
								<span className="wsm-row" style={{ gap: 8 }}>
									{n.loading ? <Spinner size={13} /> : null}
									{n.text}
								</span>
							</Banner>
						))}
					</div>
				) : null}
				<div className="wsm-table-wrap">
					<table className="wsm-table" style={{ minWidth: 620 }}>
						<thead>
							<tr>
								<th className="w-check">
									<input type="checkbox" aria-label={t('Sayfadakileri seç')} checked={allOn} disabled={!eligible.length} onChange={(e) => this.togglePage(eligible, e.target.checked)} />
								</th>
								<th>{t('İsim')}</th>
								<th>{t('Numara')}</th>
								{R.showLine ? <th>{t('Hat')}</th> : null}
								<th>{t('label')}</th>
								<th>{t('type')}</th>
								<th>{t('Durum')}</th>
							</tr>
						</thead>
						<tbody>
							{pageRows.map((r) => (
								<tr key={r.key} className={cs({ sel: r.checked, off: r.blacklisted })}>
									<td>
										<input type="checkbox" aria-label={t('Seç')} checked={r.checked} disabled={r.blacklisted} onChange={r.toggle} />
									</td>
									<td style={{ fontWeight: 500 }}>{r.name || <span className="wsm-faint">—</span>}</td>
									<td className="wsm-muted wsm-nowrap">{r.phone || <span className="wsm-faint">—</span>}</td>
									{R.showLine ? <td className="wsm-muted wsm-nowrap">{r.line}</td> : null}
									<td>{this.renderTags(r.tags)}</td>
									<td className="wsm-muted">{r.type}</td>
									<td>{r.blacklisted ? <Badge>{t('Kara liste')}</Badge> : r.checked ? <Badge tone="ok">{t('Seçili')}</Badge> : <Badge tone="info">{t('Hazır')}</Badge>}</td>
								</tr>
							))}
							{!pageRows.length ? (
								<tr>
									<td colSpan={R.showLine ? 7 : 6} className="wsm-empty-row">
										{R.rows.length ? t('Aramanızla eşleşen kayıt bulunamadı.') : R.notices.length ? '' : emptyText}
									</td>
								</tr>
							) : null}
						</tbody>
					</table>
				</div>
				<Pager
					page={st.page}
					pageSize={PAGE_SIZE}
					total={rows.length}
					onChange={(page) => this.setState({ page })}
					label={`${num(rows.length)} ${t('kayıt')} · ${num(st.targets.length)} ${t('seçili')}`}
				/>
			</>
		);
	}
	togglePage(rows, on) {
		_.each(rows, (r) => {
			if (r.checked !== on) r.toggle();
		});
	}

	// ── Adım 2: Mesaj ──
	renderTemplateFields() {
		let { t } = this.props;
		let { template_id, template_config, templateLoading, template_image, selectedBusinessphone, templates } = this.state;
		let tpl = this.getSelectedTemplate(template_id);
		let header = tpl && _.find(tpl.components, (c) => (c.type || '').toUpperCase() === 'HEADER');
		let hasMedia = header && /IMAGE|VIDEO|DOCUMENT/.test((header.format || '').toUpperCase());
		// Gönderim şablonu ada göre seçer; aynı adlı (farklı dil / tekrar eden) kayıtlar tek satırda
		let options = _.map(_.groupBy(templates, 'name'), (list, name) => ({
			value: name,
			label: name,
			meta: _.compact([_.capitalize(list[0].category || ''), _.uniq(_.compact(_.map(list, 'language'))).join(', ')]).join(' · '),
		}));
		return (
			<>
				<Field
					label={t('Template')}
					required
					hint={t('Yalnızca onaylı şablonlar listelenir.')}
					right={
						<div className="wsm-row" style={{ gap: 10 }}>
							{template_config && template_config.partner ? (
								<button
									type="button"
									className="wsm-btn link"
									disabled={templateLoading}
									onClick={() => {
										this.setState({ templateLoading: true });
										this.getBusinessTemplates(true);
									}}
								>
									{templateLoading ? t('Yenileniyor…') : t("Meta'dan yenile")}
								</button>
							) : null}
							{template_config && template_config.waba_gen_id ? (
								<Link
									className="wsm-btn link"
									target="_blank"
									to={`/wsendmessage/templates/new?waba_gen_id=${template_config.waba_gen_id}&shop=${encodeURIComponent(selectedBusinessphone || '')}`}
								>
									+ {t('newTemplate')}
								</Link>
							) : null}
						</div>
					}
				>
					<Combo
						mono
						value={template_id}
						options={options}
						disabled={templateLoading || !templates}
						placeholder={templateLoading || !templates ? t('Yükleniyor…') : options.length ? t('Şablon seçin') : t('Onaylı şablon yok')}
						searchPlaceholder={t('Şablon adı veya içerik ara…')}
						emptyText={t('Filtrelerle eşleşen şablon yok.')}
						onChange={(v) => this.handleChange(null, { name: 'template_id', value: v })}
					/>
				</Field>
				{hasMedia || template_image ? (
					<Field
						label={t('Medya') + ' (' + t('isteğe bağlı') + ')'}
						hint={t('Boş bırakılırsa şablonun örnek medyası gönderilir. Test sırasında medya hatası aldıysanız yeni bir dosya yükleyin.')}
					>
						<div className="wsm-row" style={{ flexWrap: 'nowrap' }}>
							<Input value={template_image} onChange={(v) => this.setState({ template_image: v })} placeholder="https://…" />
							{this.uploadButton('template_image')}
							{template_image ? <IconBtn icon="x" size={40} title={t('Temizle')} onClick={() => this.setState({ template_image: '' })} /> : null}
						</div>
					</Field>
				) : null}
				{this.renderTemplateVarsFields()}
				{this.renderCarouselFields()}
			</>
		);
	}
	renderTemplateVarsFields() {
		let { t } = this.props;
		let { template_vars, template_params } = this.state;
		if (!template_vars || !template_vars.length) return null;
		let fieldOptions = _.map(this.getAvailableFields(), (it) => ({ value: it.value, label: it.text }));
		let modeOptions = [
			{ value: 'text', label: t('Sabit metin') },
			{ value: 'field', label: t('Listeden al') },
		];
		return (
			<div className="wsm-subcard">
				<div>
					<div className="wsm-subcard-title">{t('Şablon değişkenleri')}</div>
					<div className="wsm-hint">{t('Her değişken için sabit bir metin girin ya da listedeki bir kolondan (ör. Name) doldurun.')}</div>
				</div>
				{_.map(template_vars, (v) => {
					let tp = (template_params && template_params[v.id]) || { mode: 'text', value: '' };
					return (
						<div key={v.id} className="wsm-var">
							<span className="wsm-code">{v.code}</span>
							<Select value={tp.mode} options={modeOptions} onChange={(mode) => this.setTemplateParam(v.id, { mode, value: '' })} />
							{tp.mode === 'field' ? (
								<Select value={tp.value} options={fieldOptions} placeholder={t('Alan seç')} onChange={(value) => this.setTemplateParam(v.id, { ...tp, value })} />
							) : (
								<Input value={tp.value} placeholder={`${v.code} ${t('için değer')}`} onChange={(value) => this.setTemplateParam(v.id, { ...tp, value })} />
							)}
						</div>
					);
				})}
			</div>
		);
	}
	renderCarouselFields() {
		let { t } = this.props;
		let { template_cards, template_carousel_type, template_id } = this.state;
		if (!template_cards) return null;
		let tpl = this.getSelectedTemplate(template_id);
		let carousel = this.getCarouselComp(tpl);
		let isProduct = template_carousel_type === 'PRODUCT';
		return (
			<div className="wsm-subcard">
				<div>
					<div className="wsm-subcard-title">{isProduct ? t('Ürün kartları') : t('Carousel kartları')}</div>
					{isProduct ? <div className="wsm-hint">{t('Katalogdaki ürün ID’lerini girin. Onaydaki kart sayısından farklı sayıda (2-10) ürün gönderebilirsiniz.')}</div> : null}
				</div>
				{_.map(template_cards, (card, ci) => {
					let tplCard = carousel && carousel.cards && (carousel.cards[ci] || carousel.cards[0]);
					let bodyComp = tplCard && _.find(tplCard.components, (c) => (c.type || '').toUpperCase() === 'BODY');
					let btnComp = tplCard && _.find(tplCard.components, (c) => (c.type || '').toUpperCase() === 'BUTTONS');
					let allBtns = (btnComp && btnComp.buttons) || [];
					return (
						<div key={ci} className="wsm-subcard" style={{ background: '#F8FAFB' }}>
							<div className="wsm-subcard-title">
								<span>
									{t('Kart')} {ci + 1}
								</span>
								{isProduct && template_cards.length > 2 ? <IconBtn icon="trash" danger title={t('Kartı sil')} onClick={() => this.removeProductCard(ci)} /> : null}
							</div>
							{isProduct ? (
								<div className="wsm-grid2">
									<Field label={t('Ürün ID (product_retailer_id)')}>
										<Input value={card.product_retailer_id} onChange={(v) => this.setCardField(ci, { product_retailer_id: v })} />
									</Field>
									<Field label={t('Katalog ID (ops.)')}>
										<Input value={card.catalog_id} onChange={(v) => this.setCardField(ci, { catalog_id: v })} />
									</Field>
								</div>
							) : (
								<>
									<Field label={t('Kart görseli (URL)')}>
										<div className="wsm-row" style={{ flexWrap: 'nowrap' }}>
											<Input value={card.url} placeholder="https://…" onChange={(v) => this.setCardField(ci, { url: v })} />
											<label className="wsm-iconbtn" style={{ width: 40, height: 40, cursor: 'pointer' }} title={t('Dosya yükle')}>
												<Icon name="upload" size={15} />
												<input type="file" accept="image/jpeg,image/png" style={{ display: 'none' }} onChange={this.uploadCardImage(ci)} />
											</label>
										</div>
									</Field>
									{bodyComp &&
										(card.body_params || []).map((v, ai) => (
											<Field key={ai} label={`${t('Kart değişkeni')} {{${ai + 1}}}`}>
												<Input value={v} onChange={(val) => this.setCardArrayField(ci, 'body_params', ai, val)} />
											</Field>
										))}
									{allBtns.map((b, bi) => {
										let type = (b.type || '').toUpperCase();
										let isDynUrl = type === 'URL' && /{{\d+}}/.test(b.url || '');
										return (
											<Field
												key={bi}
												label={
													<span className="wsm-row" style={{ gap: 6 }}>
														<Icon name={type === 'URL' ? 'link' : type === 'PHONE_NUMBER' ? 'phone' : 'reply'} size={13} />
														{b.text || type}
														<span className="wsm-faint" style={{ fontWeight: 400 }}>
															({t('başlık sabit')})
														</span>
													</span>
												}
												hint={isDynUrl ? t('Sadece değişkenin yerine gelecek kısmı girin.') + ' ' + b.url : type === 'URL' ? b.url : null}
											>
												{isDynUrl ? (
													<Input
														value={(card.buttons && card.buttons[bi] && card.buttons[bi].url) || ''}
														placeholder={(b.url || '').replace(/.*{{\d+}}/, '')}
														onChange={(val) => this.setCardArrayField(ci, 'buttons', bi, val)}
													/>
												) : null}
											</Field>
										);
									})}
								</>
							)}
						</div>
					);
				})}
				{isProduct && template_cards.length < 10 ? (
					<Btn variant="dashed" icon="plus" onClick={this.addProductCard}>
						{t('Kart ekle')}
					</Btn>
				) : null}
			</div>
		);
	}
	renderContentFields() {
		let { t } = this.props;
		let { message_type, message, text_message } = this.state;
		let accepts = { media: '*', document: '.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf', audio: 'audio/*', gif: '.mp4', sticker: '.webp' };
		let withText = message_type === 'media' || message_type === 'link' || message_type === 'gif';
		return (
			<>
				{message_type === 'text' ? (
					<Field label={t('message')} required right={this.editorBar('message')}>
						<Textarea id="message_area" rows={6} value={message} placeholder={t('MesajGirin')} onChange={(v) => this.setState({ message: v })} />
					</Field>
				) : (
					<Field label={message_type === 'link' ? 'Link' : 'Url'} required hint={message_type === 'link' ? null : t('Bağlantı girin veya dosya yükleyin.')}>
						<div className="wsm-row" style={{ flexWrap: 'nowrap' }}>
							<Input value={message} placeholder={t('LinkGirin')} onChange={(v) => this.setState({ message: v })} />
							{message_type !== 'link' ? this.uploadButton(undefined, accepts[message_type]) : null}
							{message ? <IconBtn icon="x" size={40} title={t('Temizle')} onClick={() => this.setState({ message: '' })} /> : null}
						</div>
					</Field>
				)}
				{withText ? (
					<Field label={t('Yazı') + ' (' + t('isteğe bağlı') + ')'} right={this.editorBar('text')}>
						<Textarea id="message_area_text" rows={4} value={text_message} placeholder={t('Mesajops')} onChange={(v) => this.setState({ text_message: v })} />
					</Field>
				) : null}
			</>
		);
	}
	renderMessage() {
		let { t } = this.props;
		let { selectedSource, message_type, message_name, testNumber } = this.state;
		let waba = selectedSource === 'waba';
		let ready = !this.stepError(1);
		return (
			<>
				<div className="wsm-section wsm-col">
					{!waba ? (
						<Field label={t('messageType')}>
							<Segmented value={message_type} options={this.getMessageTypes()} onChange={(v) => this.handleChange(null, { name: 'message_type', value: v })} />
						</Field>
					) : null}
					<Field label={t('Kampanya adı')} hint={t('Geçmiş ve raporlarda bu adla görünür.')}>
						<Input value={message_name} placeholder={t('Ör. Ekim kampanyası')} onChange={(v) => this.setState({ message_name: v })} />
					</Field>
					{message_type === 'template' ? this.renderTemplateFields() : this.renderContentFields()}
				</div>
				<div className="wsm-section">
					<Field label={t('testNumber')} hint={t('testAlert')}>
						<div className="wsm-row" style={{ flexWrap: 'nowrap' }}>
							<Input type="tel" value={testNumber} placeholder="905XXXXXXXXX" onChange={(v) => this.setState({ testNumber: v.replace(/[^\d]/g, '') })} />
							<Btn variant="outline" icon="send" disabled={!testNumber || !ready} onClick={() => this.setState({ openTestModal: true })}>
								{t('testSend')}
							</Btn>
						</div>
					</Field>
				</div>
			</>
		);
	}

	// ── Adım 3: Zamanlama & Gönder ──
	summaryRows() {
		let { t } = this.props;
		let { selectedSource, targets, message_type, template_id, message, message_name, sending_date, startDate, selectedAralik } = this.state;
		let waba = selectedSource === 'waba';
		let delay = this.props.product.settings.wsendwithdelay;
		let typeOpt = _.find(this.getMessageTypes(), { value: message_type });
		let rows = [
			{ label: t('Alıcı'), value: num(targets.length) },
			{ label: t('Kanal'), value: waba ? 'WhatsApp Business' : 'WhatsApp Web' },
			{ label: t('Hat'), value: this.lineLabel() },
			{ label: t('messageType'), value: (typeOpt && typeOpt.label) || message_type },
			message_type === 'template'
				? { label: t('Template'), value: template_id || '—' }
				: { label: t('message'), value: message ? _.truncate(message, { length: 40 }) : '—' },
		];
		if (message_name) rows.push({ label: t('Kampanya adı'), value: message_name });
		if (!delay && sending_date === 'local') {
			let waves = _.sortBy(_.filter(this.getWaves(), 'send_at'), (w) => w.send_at.getTime());
			rows.push({
				label: t('Gönderim'),
				value: waves.length ? `${waves.length} ${t('dalga')} · ${waves[0].ref} – ${waves[waves.length - 1].ref}` : '—',
				color: COLORS.info,
			});
		} else if (!delay)
			rows.push({
				label: t('Gönderim'),
				value: sending_date === 'next' ? moment(startDate).format('DD.MM.YYYY HH:mm') : t('Hemen'),
				color: sending_date === 'next' ? COLORS.info : undefined,
			});
		if (!waba && !delay && targets.length > 1) {
			rows.push({ label: t('sendRange'), value: formatTime(selectedAralik) });
			rows.push({ label: t('Tahmini süre'), value: formatTimeText(selectedAralik * (targets.length - 1)) });
		}
		return rows;
	}
	// Zamanlama adımının hatası (geçmişte kalan dalga vb.)
	scheduleError() {
		let { t } = this.props;
		let { sending_date, startDate } = this.state;
		if (this.props.product.settings.wsendwithdelay) return '';
		if (sending_date === 'next' && moment(startDate).isBefore(moment())) return t('Seçilen zaman geçmişte kalıyor.');
		if (sending_date === 'local') {
			let past = _.filter(this.getWaves(), (w) => !w.send_at || w.send_at.getTime() < Date.now() + 60000);
			if (past.length) return t('Bazı ülkelerde seçilen saat geçmişte kalıyor') + ': ' + _.map(past, 'label').join(', ');
		}
		return '';
	}
	renderWaves() {
		let { t } = this.props;
		let { weekendRule, tzOverrides } = this.state;
		let waves = this.getWaves();
		let refTz = browserTz();
		let now = Date.now();
		let tzOptions = _.map(TIMEZONES, (tz) => ({ value: tz, label: tz + ' (' + tzOffsetLabel(tz) + ')' }));
		return (
			<>
				<Field label={t('Hafta sonuna denk gelirse')}>
					<Select
						value={weekendRule || 'asis'}
						onChange={(v) => this.setState({ weekendRule: v })}
						options={[
							{ value: 'asis', label: t('Olduğu gibi gönder') },
							{ value: 'next_business', label: t('Bir sonraki iş gününe kaydır') },
						]}
					/>
				</Field>
				<div style={{ border: '1px solid #E2E7EC', borderRadius: 10, overflow: 'hidden' }}>
					<div className="wsm-table-wrap">
						<table className="wsm-table" style={{ minWidth: 640 }}>
							<thead>
								<tr>
									<th>{t('Ülke')}</th>
									<th className="r">{t('Alıcı')}</th>
									<th>{t('Saat dilimi')}</th>
									<th>{t('Yerel saat')}</th>
									<th>
										{t('Sizin saatiniz')} ({tzOffsetLabel(refTz)})
									</th>
								</tr>
							</thead>
							<tbody>
								{waves.map((w) => {
									let past = !w.send_at || w.send_at.getTime() < now + 60000;
									return (
										<tr key={w.code}>
											<td style={{ fontWeight: 500 }}>
												{w.unknown ? t('Belirlenemeyen') : w.label}
												{w.unknown ? <div className="wsm-hint">{t('Ülke kodu yok (ör. gruplar); sizin saat diliminizle gider.')}</div> : null}
											</td>
											<td className="r">{num(w.targets.length)}</td>
											<td>
												<Select
													small
													value={w.tz}
													options={tzOptions}
													onChange={(tz) => this.setState({ tzOverrides: { ...(tzOverrides || {}), [w.code]: tz } })}
												/>
											</td>
											<td className="wsm-nowrap" style={{ fontWeight: 600, color: past ? COLORS.danger : COLORS.primary }}>
												{w.local}
												{w.shifted ? <div className="wsm-hint">{t('Hafta sonundan kaydırıldı')}</div> : null}
												{past ? <div className="wsm-hint" style={{ color: COLORS.danger }}>{t('Geçmişte kalıyor')}</div> : null}
											</td>
											<td className="wsm-muted wsm-nowrap">{w.ref}</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>
				</div>
				<div className="wsm-hint">{t('Her ülke ayrı bir planlı gönderim olarak oluşturulur; Planlamalar ve Geçmiş sekmesinde ayrı satırlar görünür.')}</div>
			</>
		);
	}
	renderSchedule() {
		let { t, i18n, product } = this.props;
		let { selectedSource, sending_date, startDate, selectedAralik, lasttime, targets } = this.state;
		let waba = selectedSource === 'waba';
		let delay = product.settings.wsendwithdelay;
		let max_phone_length = _.round(moment(lasttime).diff(moment(), 'seconds') / 60);
		let missing = this.stepError(0) || this.stepError(1) || this.scheduleError();
		return (
			<>
				<div className="wsm-section wsm-col">
					{!delay ? (
						<Field label={t('date')}>
							<Segmented
								grow
								value={sending_date}
								onChange={(v) => this.setState({ sending_date: v })}
								options={[
									{ value: 'now', label: t('now'), icon: 'send' },
									{ value: 'next', label: t('nextDate'), icon: 'calendar' },
									{ value: 'local', label: t('Ülke saatine göre'), icon: 'clock' },
								]}
							/>
						</Field>
					) : null}
					{!delay && (sending_date === 'next' || sending_date === 'local') ? (
						<Field
							label={sending_date === 'local' ? t('Yerel tarih ve saat') : t('Tarih ve saat')}
							hint={sending_date === 'local' ? t('Alıcılar telefon ülke koduna göre gruplanır; her gruba kendi yerel saatinde gönderilir.') : null}
						>
							<DatePicker
								className="wsm-input"
								selected={startDate}
								onChange={(date) => this.setState({ startDate: date })}
								minDate={sending_date === 'local' ? moment().subtract(1, 'day').toDate() : new Date()}
								filterTime={sending_date === 'local' ? undefined : filterPassedTime}
								showTimeSelect
								timeFormat="HH:mm"
								timeIntervals={5}
								dateFormat="dd.MM.yyyy HH:mm"
								timeCaption={t('time')}
								locale={dateLocales[i18n.language]}
							/>
						</Field>
					) : null}
					{!delay && sending_date === 'local' ? this.renderWaves() : null}
					{!waba && !delay ? (
						<Field label={t('sendRange')} hint={t('sendRangeAlert')}>
							<Select value={selectedAralik} options={_.map(time_options, (o) => ({ value: o.value, label: o.text }))} onChange={(v) => this.setState({ selectedAralik: v })} />
						</Field>
					) : null}
					{delay ? (
						<>
							<Field label={t('Bitiş saati')}>
								<DatePicker
									className="wsm-input"
									selected={lasttime}
									onChange={(date) => this.setState({ lasttime: date })}
									minDate={new Date()}
									maxDate={new Date()}
									filterTime={filterPassedTime}
									showTimeSelect
									showTimeSelectOnly
									timeFormat="HH:mm"
									timeIntervals={5}
									dateFormat="HH:mm"
									timeCaption={t('time')}
									locale={dateLocales[i18n.language]}
								/>
							</Field>
							<Banner tone="info">
								{t('{{time}} saatine kadar her dakika bir numaraya mesaj gönderilir. En fazla {{n}} numaraya gönderilebilir; fazlası gönderilmez.', { time: moment(lasttime).format('HH:mm'), n: Math.max(0, max_phone_length) })}
								{targets.length > max_phone_length ? <div style={{ marginTop: 4, color: COLORS.warn }}>{t('Seçili alıcı sayısı bu sınırı aşıyor.')}</div> : null}
							</Banner>
						</>
					) : null}
				</div>
				<div className="wsm-section wsm-col" style={{ gap: 12 }}>
					<div className="wsm-subcard-title">{t('Özet')}</div>
					<KV rows={this.summaryRows()} />
					{missing ? <Banner>{missing}</Banner> : null}
				</div>
			</>
		);
	}

	renderPreview() {
		let { message_type, template_id, template_params, template_image, template_cards, message, text_message, file_format, file_name } = this.state;
		return (
			<WaFrame title={this.props.t('Canlı önizleme')}>
				{message_type === 'template' ? (
					<TemplateBubble tpl={this.getSelectedTemplate(template_id)} params={template_params} image={template_image} cards={template_cards} />
				) : (
					<MessageBubble type={message_type} message={message} text={text_message} fileFormat={file_format} fileName={file_name} />
				)}
			</WaFrame>
		);
	}
	// Sağ panel: sabit yükseklikte, içi kayar; genişletilebilir / gizlenebilir.
	renderAside() {
		let { t } = this.props;
		let { aside, targets, step, selectedSource, template_id } = this.state;
		if (aside === 'collapsed')
			return (
				<Card className="wsm-aside rail">
					<div className="wsm-aside-head">
						<IconBtn icon="panelOpen" title={t('Önizlemeyi göster')} onClick={() => this.setAside('normal')} />
						<span className="wsm-rail-label">{t('Önizleme & özet')}</span>
					</div>
				</Card>
			);
		let wide = aside === 'wide';
		return (
			<Card className="wsm-aside">
				<div className="wsm-aside-head">
					<h3 className="wsm-card-title">{t('Önizleme & özet')}</h3>
					<Badge tone="ok">
						{num(targets.length)} {t('seçili')}
					</Badge>
					<IconBtn icon={wide ? 'minimize' : 'maximize'} title={wide ? t('Daralt') : t('Genişlet')} onClick={() => this.setAside(wide ? 'normal' : 'wide')} />
					<IconBtn icon="panelClose" title={t('Paneli gizle')} onClick={() => this.setAside('collapsed')} />
				</div>
				<div className="wsm-aside-body">
					{this.renderPreview()}
					<KV
						rows={_.compact([
							{ label: t('Kanal'), value: selectedSource === 'waba' ? 'WhatsApp Business' : 'WhatsApp Web' },
							{ label: t('Hat'), value: this.lineLabel() },
							selectedSource === 'waba' ? { label: t('Template'), value: template_id || '—' } : null,
						])}
					/>
					{step === 0 && targets.length ? (
						<div className="wsm-col" style={{ gap: 6 }}>
							<div className="wsm-label-row">
								<span className="wsm-label">{t('Seçilenler')}</span>
								<button type="button" className="wsm-btn link" onClick={() => this.setState({ openListModal: true })}>
									{t('Tümünü gör')}
								</button>
							</div>
							<div className="wsm-tags">
								{targets.slice(0, 12).map((it, i) => (
									<Tag key={i}>{it.name || it.id}</Tag>
								))}
								{targets.length > 12 ? <Tag>+{num(targets.length - 12)}</Tag> : null}
							</div>
						</div>
					) : null}
				</div>
			</Card>
		);
	}
	renderStepHeadRight(step, R) {
		let { t } = this.props;
		if (step !== 0) return null;
		return (
			<>
				{R.selectAll ? (
					<Btn variant="ghost" size="s" onClick={R.selectAll}>
						{t('selectAll')}
					</Btn>
				) : null}
				<Btn variant="ghost" size="s" onClick={() => this.setState({ targets: [] })} disabled={!this.state.targets.length}>
					{t('Temizle')}
				</Btn>
				<Btn variant="soft" size="s" icon="list" onClick={() => this.setState({ openListModal: true })}>
					{t('Seçili')} ({num(this.state.targets.length)})
				</Btn>
			</>
		);
	}
	renderNav() {
		let { t } = this.props;
		let { step, targets, btnLoading, sending_date } = this.state;
		let err = this.stepError(step);
		let sendErr = this.stepError(0) || this.stepError(1) || this.scheduleError();
		let planned = (sending_date === 'next' || sending_date === 'local') && !this.props.product.settings.wsendwithdelay;
		return (
			<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
				{step > 0 ? (
					<Btn variant="ghost" icon="chevronLeft" onClick={() => this.goStep(step - 1)}>
						{t('Geri')}
					</Btn>
				) : (
					<span />
				)}
				<span className="wsm-stepnav-info" style={err ? { color: COLORS.warn } : undefined}>
					{err || `${num(targets.length)} ${t('alıcı seçili')}`}
				</span>
				{step < 2 ? (
					<Btn disabled={!!err} onClick={() => this.goStep(step + 1)}>
						{t('Devam')}
						<Icon name="chevronRight" size={16} />
					</Btn>
				) : (
					<Btn icon={planned ? 'calendar' : 'send'} disabled={!!sendErr} busy={btnLoading} onClick={() => this.setState({ openModal: true })}>
						{planned ? t('Gönderimi planla') : t('{{n}} kişiye gönder', { n: num(targets.length) })}
					</Btn>
				)}
			</div>
		);
	}
	renderMain() {
		let { t } = this.props;
		let { step, aside } = this.state;
		let heads = [
			[t('Alıcılar'), t('Kaynağı ve hattı seçin, listeyi filtreleyip göndermek istediğiniz kişileri işaretleyin.')],
			[t('Mesaj'), t('Mesaj tipini seçip içeriği hazırlayın; önizleme sağda güncellenir.')],
			[t('Zamanlama & Gönder'), t('Gönderim zamanını belirleyin, özeti kontrol edip gönderin.')],
		];
		let R = step === 0 ? this.buildRecipients() : null;
		let body = step === 0 ? this.renderRecipients(R) : step === 1 ? this.renderMessage() : this.renderSchedule();
		return (
			<div className={cs('wsm-split', { wide: aside === 'wide', collapsed: aside === 'collapsed' })}>
				<Card>
					<CardHead title={heads[step][0]} desc={heads[step][1]} right={this.renderStepHeadRight(step, R)} />
					{body}
					<div className="wsm-stepnav">{this.renderNav()}</div>
				</Card>
				{this.renderAside()}
			</div>
		);
	}
	renderModals() {
		let { t, product } = this.props;
		let { openModal, openListModal, openTestModal, importOpen, targets, btnLoading, testNumber, selectedBusinessphone, sending_date, startDate, lasttime } = this.state;
		let delay = product.settings.wsendwithdelay;
		let max_phone_length = _.round(moment(lasttime).diff(moment(), 'seconds') / 60);
		let typeOf = (it) => (it.phone === 'waba' ? t('Kişi') : it.type === 'chat' || /@c\.us/.test(it.id) ? t('Kişi') : t('Grup'));
		let lineOf = (it) => (it.phone === 'waba' ? selectedBusinessphone : it.phone);
		return (
			<>
				{importOpen ? (
					<ImportModal
						t={t}
						onClose={() => this.setState({ importOpen: false })}
						onImported={async (data) => {
							this.setState({ importOpen: false });
							await this.getListExcel();
							if (data.list && data.list.id) this.setState({ phoneSource: 'excel_' + data.list.id, page: 1 });
							notify(t('Liste içe aktarıldı') + (data.list && data.list.row_count ? ': ' + num(data.list.row_count) + ' ' + t('kişi') : ''));
						}}
					/>
				) : null}
				{openModal ? (
					<Modal
						title={(sending_date === 'next' || sending_date === 'local') && !delay ? t('Gönderimi planla') : t('Gönderim onayı')}
						desc={t('sendGroupsSure')}
						icon="send"
						width={760}
						busy={btnLoading}
						onClose={this.closeModal}
						footer={
							<>
								<Btn variant="ghost" onClick={this.closeModal} disabled={btnLoading}>
									{t('no')}
								</Btn>
								<Btn
									icon="check"
									busy={btnLoading || this.state.wavesSending}
									onClick={() => (sending_date === 'local' && !delay ? this.sendWaves() : this.sendMessage(false))}
								>
									{t('yes')}
								</Btn>
							</>
						}
					>
						<div className="wsm-grid2" style={{ alignItems: 'start' }}>
							{this.renderPreview()}
							<div className="wsm-col" style={{ gap: 12 }}>
								<KV rows={this.summaryRows()} />
								{sending_date === 'next' && !delay ? <Banner tone="info">{t('messageSendingDate', { date: moment(startDate).format('DD/MM/YYYY HH:mm') })}</Banner> : null}
								{sending_date === 'local' && !delay ? (
									<Banner tone="info">
										{_.map(this.getWaves(), (w) => (
											<div key={w.code}>
												{w.unknown ? t('Belirlenemeyen') : w.label}: <strong>{w.local}</strong> · {num(w.targets.length)} {t('alıcı')}
											</div>
										))}
									</Banner>
								) : null}
								{delay ? (
									<Banner>
										{t('{{time}} saatine kadar her dakika bir numaraya mesaj gönderilir. En fazla {{n}} numaraya gönderilebilir; fazlası gönderilmez.', { time: moment(lasttime).format('HH:mm'), n: Math.max(0, max_phone_length) })}
									</Banner>
								) : null}
							</div>
						</div>
						<div style={{ marginTop: 16, border: '1px solid #E2E7EC', borderRadius: 10, overflow: 'hidden' }}>
							<div className="wsm-table-wrap" style={{ maxHeight: 220, overflowY: 'auto' }}>
								<table className="wsm-table">
									<tbody>
										{targets.slice(0, 300).map((it, i) => (
											<tr key={i}>
												<td>{it.name || it.id}</td>
												<td className="wsm-muted">{phoneOf(it.id)}</td>
												<td className="wsm-muted">{typeOf(it)}</td>
												<td className="wsm-muted">{lineOf(it)}</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
							{targets.length > 300 ? <div className="wsm-pager">{`300 / ${num(targets.length)} ${t('alıcı gösteriliyor')}`}</div> : null}
						</div>
					</Modal>
				) : null}
				{openListModal ? (
					<Modal
						title={`${t('Seçilenler')} (${num(targets.length)})`}
						icon="users"
						width={760}
						onClose={() => this.setState({ openListModal: false })}
						bodyStyle={{ padding: 0 }}
						footer={
							<>
								<Btn variant="ghost" icon="trash" disabled={!targets.length} onClick={() => this.setState({ targets: [] })}>
									{t('deSelectAll')}
								</Btn>
								<Btn onClick={() => this.setState({ openListModal: false })}>{t('Tamam')}</Btn>
							</>
						}
					>
						<table className="wsm-table">
							<thead>
								<tr>
									<th>{t('name')}</th>
									<th>{t('phone')}</th>
									<th>{t('type')}</th>
									<th>{t('Hat')}</th>
									<th />
								</tr>
							</thead>
							<tbody>
								{targets.map((it, i) => (
									<tr key={i + '_' + it.id}>
										<td>{it.name || it.id}</td>
										<td className="wsm-muted">{phoneOf(it.id)}</td>
										<td className="wsm-muted">{typeOf(it)}</td>
										<td className="wsm-muted">{lineOf(it)}</td>
										<td className="r">
											<IconBtn icon="x" title={t('Çıkar')} onClick={() => this.removeTarget(i)} />
										</td>
									</tr>
								))}
								{!targets.length ? (
									<tr>
										<td colSpan={5} className="wsm-empty-row">
											{t('Henüz alıcı seçilmedi.')}
										</td>
									</tr>
								) : null}
							</tbody>
						</table>
					</Modal>
				) : null}
				{openTestModal ? (
					<ConfirmModal
						title={t('testSend')}
						desc={`${t('Mesaj yollanacak numara')}: ${testNumber}`}
						icon="send"
						tone="primary"
						confirmText={t('yes')}
						cancelText={t('no')}
						busy={btnLoading}
						onClose={this.closeModal}
						onConfirm={() => this.sendMessage(true)}
						body={this.renderPreview()}
					/>
				) : null}
			</>
		);
	}

	render() {
		let { t } = this.props;
		let { loading, step } = this.state;
		if (loading) return <Page.Loader></Page.Loader>;
		return (
			<div>
				<div className="wsm-send-top">
					<Stepper steps={[t('Alıcılar'), t('Mesaj'), t('Zamanlama & Gönder')]} current={step} onStep={this.goStep} canGo={this.canGo} />
				</div>
				{this.renderMain()}
				{this.renderModals()}
			</div>
		);
	}
}

const stateToProps = (state) => {
	return { access: state.access, location: state.router.location, product: state.product.live, user: state.access.user.loggedUserObj };
};
export default connect(stateToProps)(withTranslation()(Phone));
